export enum JournalDetailsScreen {
  fiveMinuteDetails = "FiveMinuteDetails",
  gratitudeDetails = "GratitudeDetails",
  iAmGreatDetails = "IAmGreatDetails",
  diaryDetails = "DiaryDetails",
  tagDetails = "TagDetails",
}
